import React, { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";

export default function FilterButton(props) {
  const [filterOpen, setfilterOpen] = React.useState(true);
  const { t, i18n } = useTranslation();

  const handleChange = () => {
    setfilterOpen(!filterOpen);
    const btn_el = document.querySelector(".js-btn-filter");
    const panel_el = document.querySelector(".js-filters-panel");


    btn_el.classList.toggle('open');
    panel_el.classList.toggle('filters-open');


  };

  return (
    <button
      className="form__btn-filters section__btn-filter js-btn-filter open"
      onClick={() => {
        handleChange();
      }}
    >
      <figure>
        <img src="/static/images/svg/ico-filters.svg" alt="Filters icon" />
      </figure>

      <span>{t('Filter.Show')}</span>

      <span>{t('Filter.Hide')}</span>
    </button>
  );
}
